import { inject, Injectable } from '@angular/core';
import { UserService } from './user.service';
import { RouterService } from './router.service';
import { TimerControlService } from './timer-control.service';
import { AiAgentService } from './ai-agent.service';
import { LevelStartDialogComponent } from '../component/dialogs/level-start-dialog/level-start-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Route } from '../enum/route.enum';

@Injectable({ providedIn: 'root' })
export class GameService {
  private readonly userService = inject(UserService);
  private readonly timerControlService = inject(TimerControlService);
  private readonly aiAgentService = inject(AiAgentService);
  private readonly routerService = inject(RouterService);
  private readonly dialog = inject(MatDialog);

  public restartGame(): void {
    void this.userService.setLevel(1);
    this.userService.clearChatHistory();
    this.timerControlService.resetCountdown();
    this.aiAgentService.showFinishGameButton.set(false);
    this.aiAgentService.showNextLevelButton.set(false);
    this.aiAgentService.hideInputField.set(false);
    this.aiAgentService.showFinishGameAnimation.set(false);
    this.routerService.navigateTo(Route.BASE);
    // Reload user data to ensure the UI reflects the reset state
    setTimeout(() => this.userService.loadUserData(), 100);
  }

  public navigateToGame(): void {
    this.startCountdown();
    this.routerService.navigateTo(Route.GAME);
  }

  public startGame(): void {
    this.dialog.open(LevelStartDialogComponent, {
      width: '80vw',
      maxWidth: '80vw',
      disableClose: true,
      panelClass: 'animateIn',
      backdropClass: 'backdropAnimateIn',
      data: { level: 0 },
    });
    this.userService.loadUserData();
  }

  public stopCountdown() {
    this.timerControlService.stopCountdown();
  }

  public startCountdown() {
    this.timerControlService.startCountdown();
  }

  public stopPingTimer() {
    this.timerControlService.stopPingTimer();
  }

  public initTimer() {
    if (!this.timerControlService.isPingTimerRunning()) {
      this.timerControlService.startCountdown();
      this.timerControlService.startPingTimer();
    }
  }

  public setShowFinishGameAnimation() {
    this.aiAgentService.setShowFinishGameAnimation(!this.aiAgentService.showFinishGameAnimation());
  }
}
